<template>
    <div>
        <v-overlay :value="loading.data" opacity="0" z-index="4">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <v-card
            flat
            v-if="!loading.data">
            <v-card-title>
                {{ $t('ROLES_PERM_PG_TITLE') }}
                <v-spacer></v-spacer>
                <v-btn
                    v-if="authorizations.roles.create"
                    small
                    fab
                    color="primary"
                    class="ml-2"
                    @click="openPermissionDialog({editMode: false})">
                    <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-subtitle>{{ $t("ROLES_PERM_PG_SUBTITLE") }}</v-card-subtitle>
            <v-card-text>
                <v-data-table
                    :headers="permissionsHeaders"
                    :items="roles">
                    <template v-slot:item.state="{item}">
                        {{item.inactive ? "Inactive" : "Active"}}
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-menu>
                            <template v-slot:activator="{on}">
                                <v-btn
                                    icon
                                    small
                                    v-on="on">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-subheader>{{ $t("ACTIONS_MENU_TITLE") }}</v-subheader>
                                <v-list dense>
                                    <v-list-item
                                        v-if="authorizations.roles.update"
                                        link
                                        @click="openPermissionDialog({editMode: true, id: item.id})"
                                        :disabled="!item.meta.editable">
                                        <v-list-item-avatar>
                                            <v-icon :disabled="!item.meta.editable">mdi-pencil</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("ACTIONS_MENU_EDIT") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="authorizations.roles.delete"
                                        link
                                        @click="openDeletePermissionDecisionDialog(item.id)"
                                        :disabled="!item.meta.deletable">
                                        <v-list-item-avatar>
                                            <v-icon :disabled="!item.meta.deletable">mdi-delete</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("ACTIONS_MENU_DELETE") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-menu>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <PermissionDialog
            ref="permissionDialog"/>
        <DecisionDialog
            ref="decisionDialog"
            @submit="submitDecisionDialog"/>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import PermissionDialog from '../components/PermissionDialog';
import DecisionDialog from '../components/DecisionDialog';
import AlertDialog from '../components/AlertDialog';
import { mapActions, mapState } from 'vuex';
export default {
    name: "Permission",
    components: {
        PermissionDialog,
        DecisionDialog,
        AlertDialog
    },
    data() {
        return {
            permissionsHeaders: [
                {text: this.$t("ROLE_NAME"), value: "name"},
                {text: this.$t("ROLE_WORKSHOP"), value: "workshop"},
                {text: this.$t("ROLE_STATE"), value: "state"},
                {text: this.$t("ACTIONS_MENU_TITLE"), value: "actions"}
            ],
            loading: {
                data: true
            }
        }
    },
    computed: {
        ...mapState("role", ["roles"]),
        ...mapState("authentication", ["loggedInUser", "authorizations"])
    },
    methods: {
        ...mapActions("role", ["fetchRoles", "removeRole"]),
        openPermissionDialog(params) {
            this.$refs.permissionDialog.open(params);
        },
        openDeletePermissionDecisionDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t("DELETE_CONFIRM_TITLE"),
                content: this.$t("DELETE_CONFIRM_CONTENT"),
                action: "DELETE_ROLE",
                id: id
            });
        },
        submitDecisionDialog(params) {
            if(params.action == "DELETE_ROLE") {
                this.removeRole(params.id)
                    .then(response => {
                        this.fetchRoles();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            }
        }
    },
    async created() {
        await this.fetchRoles();
        this.loading.data = false;
    }
}
</script>